import React from "react";
import { Reveal, WfButton, Kicker, ImageWithCredit } from "@/components/site/primitives";
import { INTENTS } from "@/content/worldFarmers";
import { scrollToId } from "@/lib/scrollTo";

const IntentCard = ({ intent, feature }) => {
  const go = (e) => {
    e.preventDefault();
    scrollToId(intent.id === "who-we-are" ? "who-we-are" : intent.id === "support" ? "get-involved" : "events");
  };
  return (
    <article
      id={intent.id}
      data-testid={`intent-card-${intent.id}`}
      className={`group relative flex flex-col overflow-hidden rounded-sm border border-[var(--wf-border)] bg-[var(--wf-paper)] shadow-[var(--wf-shadow-sm)] transition-[box-shadow,transform] duration-300 hover:shadow-[var(--wf-shadow)] motion-safe:hover:-translate-y-0.5 ${
        feature ? "lg:row-span-2" : ""
      }`}
    >
      <div aria-hidden="true" className="h-[3px] w-full bg-[var(--wf-maroon)]" />
      <ImageWithCredit
        src={intent.image}
        alt={intent.alt}
        className={feature ? "aspect-[4/3] lg:aspect-[4/5]" : "aspect-[16/10]"}
        imgClassName="transition-transform duration-500 motion-safe:group-hover:scale-[1.04]"
      />
      <div className="flex flex-1 flex-col p-6">
        <Kicker>{intent.kicker}</Kicker>
        <h3 className="mt-3 font-serif text-2xl font-semibold text-[var(--wf-ink)]">
          {intent.title}
        </h3>
        <p className="mt-2 flex-1 text-sm leading-6 text-muted-foreground">
          {intent.body}
        </p>
        <div className="mt-5">
          <WfButton
            as="a"
            href={`#${intent.id}`}
            onClick={go}
            variant="secondary"
            withArrow
            data-testid={`intent-cta-${intent.id}`}
          >
            {intent.cta}
          </WfButton>
        </div>
      </div>
    </article>
  );
};

export const IntentHub = () => {
  const feature = INTENTS.find((i) => i.feature);
  const rest = INTENTS.filter((i) => !i.feature);
  return (
    <section id="intents" aria-labelledby="intents-heading" className="wf-section bg-[var(--wf-cream)]">
      <div className="wf-container">
        <Reveal className="max-w-2xl">
          <Kicker>Start here</Kicker>
          <h2 id="intents-heading" className="mt-3 font-serif text-3xl font-semibold text-[var(--wf-ink)] sm:text-4xl">
            Three ways to be part of the harvest
          </h2>
          <p className="mt-3 text-base leading-7 text-muted-foreground">
            Whether you’re here to shop, to give, or to get to know us — choose the path that fits you.
          </p>
        </Reveal>

        <div className="mt-10 grid grid-cols-1 gap-6 lg:grid-cols-2">
          <Reveal className="lg:col-span-1">
            {feature && <IntentCard intent={feature} feature />}
          </Reveal>
          <div className="grid grid-cols-1 gap-6">
            {rest.map((intent, idx) => (
              <Reveal key={intent.id} delay={0.08 * (idx + 1)}>
                <IntentCard intent={intent} />
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
